'use client';

import { useState } from 'react';

export function useTableFilter() {
  const [globalFilter, setGlobalFilter] = useState<string>('');

  return {
    globalFilter,
    setGlobalFilter,
  };
}
